import { UserApi } from './';

const {REACT_APP_API_BASE_URL} = process.env;

export class CoverApi {
    static getCover (eventID) {
        return fetch(`${REACT_APP_API_BASE_URL}/api/me/events/${eventID}/cover`, {
            ...UserApi.GetDefualtMethod
        });
    }

    /**
     * send multipart form data file
     * @param {String} eventID
     * @param {FormData} data 
     */
    static uploadCover (eventID, data) {
        return fetch(`${REACT_APP_API_BASE_URL}/api/me/events/${eventID}/cover`, {
            method: 'POST',
            credentials: 'include',
            mode: 'cors',
            body: data
        });
    }

    static updateCover (eventID, coverID, data) {
        return fetch(`${REACT_APP_API_BASE_URL}/api/me/events/${eventID}/cover/${coverID}`, {
            ...UserApi.PostDefualtMethod,
            method: 'PUT',
            body: JSON.stringify(data)
        });
    }

    static deleteCover (eventID, coverID) {
        return fetch(`${REACT_APP_API_BASE_URL}/api/me/events/${eventID}/cover/${coverID}`, {
            ...UserApi.PostDefualtMethod,
            method: 'DELETE'
        });
    }
}




// WEBPACK FOOTER //
// ./src/services/cover.js